import { getSchoolBankConfig } from "../../services/finance/schoolBankConfig"

export const getBankNameByEntity = async (entityCode: string): Promise<string> => {

    const bankConfigs = await getSchoolBankConfig({PageNumber:1, PageSize:100});
    const bankConfig = bankConfigs.items.find(config => config.bankEntity == entityCode);
    return bankConfig ? `${bankConfig.bankName }` : "Consulte a na secretaria";

}